import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, setSelectedProduct } from '../../../../../Features/inventoryManagementSlice';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import SearchProduct from './SearchProduct';
import UpdateStockForm from './UpdateStockForm';

function BulkUpdateHome() {
    const dispatch = useDispatch();

    const selectedProduct = useSelector((state) => state.inventoryManagement.selectedProduct);

    const handleCloseModal = () => {
        dispatch(setSelectedProduct({}));
        dispatch(closeModal());
    }

    return (
        <div className='w-[90%] h-[90%] bg-[#FFFFFF] rounded-[20px] p-[18px_24px_24px_24px] flex flex-col gap-2 shadow-[0px_0px_12px_0px_#0000003D] select-none'>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <h1 className='font-semibold text-2xl text-[#121212]'>Bulk Update</h1>
                </div>

                <button onClick={handleCloseModal} className="size-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            {
                Object.keys(selectedProduct).length > 0 ? 
                <UpdateStockForm /> : 
                <SearchProduct />
            }
        </div>
    );
}

export default BulkUpdateHome;
